import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class FinDokumentView extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavka: string;
    BrojDokumenta: string;
    Datum: NgbDate;
    Duguje:number;
    Potrazuje:number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Duguje = input.Duguje;
        this.Potrazuje = input.Potrazuje;
        return this;
    }

    Serialize(input: FinDokumentView){
        return input;
    }
}